/**
 * Left-pane IQ chat transcript entries for suggest-responsibilities-for-role outcomes.
 * Posted only after successful create-and-attach (both API steps), when the attach half
 * failed and left an orphaned Responsibility, or on reject.
 */

export function buildResponsibilityCreatedTranscriptMessage({
  codeStr,
  id,
  name,
  suggestionName,
} = {}) {
  const code = codeStr || (id != null && id !== "" ? `#${id}` : "");
  const title = String(name || suggestionName || "").trim();

  if (code && title) {
    return `Just created and attached Responsibility ${code} - ${title}`;
  }
  if (code) {
    return `Just created and attached Responsibility ${code}`;
  }
  if (title) {
    return `Created responsibility: '${title}'`;
  }
  return "Just created and attached Responsibility";
}

export function buildResponsibilityAttachFailedTranscriptMessage({
  codeStr,
  id,
  name,
  suggestionName,
} = {}) {
  const code = codeStr || (id != null && id !== "" ? `#${id}` : "");
  const title = String(name || suggestionName || "").trim();
  const label = [code, title].filter(Boolean).join(" - ");
  const subject = label ? `Responsibility ${label}` : "A responsibility";
  return `${subject} was created but could not be attached to the role. It still needs to be attached.`;
}

export function buildResponsibilityRejectedTranscriptMessage({ name } = {}) {
  const title = String(name || "").trim();
  if (!title) {
    return "Rejected suggestion";
  }
  return `Rejected suggestion: "${title}"`;
}
